// @flow
import EventEmitter from '@common/services/EventEmitter';
import ApiService from '@api/service';

import type { Error, Listener } from '@core/types';

import { API_PATHS } from '@app/constants/paths';

const {
  PARTICIPANTS_EXPORT,
  BENEFICIARIES_EXPORT,
} = API_PATHS;

type OnChange = (listener: Listener) => Function;
type FetchExport = () => Promise<boolean | null>;
type UpdateValues = (newLoading: boolean, newErrors: Error[]) => void;
type Trigger = () => void;
type FetchExportByUrl = (url: string) => Promise<boolean | null>;

class PeopleExportService {
  constructor() {
    this.eventEmitter = new EventEmitter();
    this.errors = [];
    this.loading = false;
  }

  eventEmitter: EventEmitter;
  loading: boolean;
  errors: Error[];

  updateValues: UpdateValues = (newLoading: boolean, newErrors: Error[]): void => {
    this.loading = newLoading;
    this.errors = newErrors;
    this.#trigger();
  };

  FetchParticipantsExport: FetchExport = (): Promise<boolean | null> => (
    this.#fetchExport(PARTICIPANTS_EXPORT)
  );

  FetchBeneficiariesExport: FetchExport = (): Promise<boolean | null> => (
    this.#fetchExport(BENEFICIARIES_EXPORT)
  );

  #fetchExport: FetchExportByUrl = (url: string): Promise<boolean | null> => {
    this.updateValues(true, []);

    return ApiService.request({
      method: 'get',
      url,
    })
      .catch((error) => {
        if (error?.response?.data?.violations) {
          this.updateValues(false, error.response.data.violations);
        }
        return Promise.reject();
      })
      .then(({ data }) => {
        this.updateValues(false, []);
        if (data?.link) {
          window.open(data?.link, '_blank');
          return Promise.resolve(true);
        }
        return Promise.reject();
      });
  };

  onChange: OnChange = (listener: Listener): Function => {
    const listenerFunction = this.eventEmitter.addListener(listener);
    this.#trigger();
    return listenerFunction;
  };

  /**
   * @private
   */
  #trigger: Trigger = (): void => {
    this.eventEmitter.trigger({
      loading: this.loading,
      errors: this.errors,
    });
  };
}

const instance: PeopleExportService = new PeopleExportService();
export default instance;
